import { render } from "./ModalSelectVoucher.vue?vue&type=template&id=5a778fa8"
import script from "./ModalSelectVoucher.vue?vue&type=script&lang=js"
export * from "./ModalSelectVoucher.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__